import { getProviderSelectionKey, type ProviderSelectionMatch } from "./providerSelectionKey";
import type { SelectedParcelAccount } from "./pruneUnavailableProviders";

export type ProviderWithParcelAccounts = ProviderSelectionMatch & {
  parcel_accounts?: Array<{ id: number }>;
};

export function buildAllProviderSelections(providers: ProviderWithParcelAccounts[]): {
  providers: string[];
  parcel_accounts: SelectedParcelAccount[];
} {
  const allSelectedProviders: string[] = [];
  const allSelectedParcelAccounts: SelectedParcelAccount[] = [];

  providers.forEach((item) => {
    const key = getProviderSelectionKey(item);
    allSelectedProviders.push(key);
    if (item.parcel_accounts?.length) {
      const [parcelAccount] = item.parcel_accounts;
      allSelectedParcelAccounts.push({
        parcel_account_id: parcelAccount.id,
        provider_id: key,
      });
    }
  });

  return { providers: allSelectedProviders, parcel_accounts: allSelectedParcelAccounts };
}
